import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";


type TuseMainPageItems = {
    mapLayoutName:string;
}

const useMainPageItems = ( props:TuseMainPageItems ):TClientMainPageItemList[]|null => {
    const armadorStaticPayload = document?.getElementById('ARMADORPayload')?.textContent;
    const _armadorStaticPayload = JSON.parse(armadorStaticPayload||"");
    
    return _armadorStaticPayload?.[props.mapLayoutName];
}

export default useMainPageItems;
